// Modals

(function () {
    // Add Current Date to Date Input
    const removeNomineeDateInputs = document.querySelectorAll("#remove_nominee_date");
    if (!removeNomineeDateInputs || removeNomineeDateInputs.length === 0) {
        return;
    }
    const today = new Date().toISOString().split("T")[0];
    removeNomineeDateInputs.forEach((input) => {
        input.value = today;
    });

    // Confirm Remove Contact Person
    var removeContactForms = document.querySelectorAll('form[id^="form_email_del_emergency_contact_"]');

    // Attach event listeners to each form
    removeContactForms.forEach(function (form) {
        form.addEventListener("submit", function (event) {
            event.preventDefault();

            // Get the unique number from the form ID
            // var formId = form.id.split("_").pop();

            var personIdInput = form.querySelector('input[name="personid"]');
            var personid = personIdInput ? personIdInput.value : "";

            var contactpersonIdInput = form.querySelector('input[name="contactpersonid"]');
            var contactpersonid = contactpersonIdInput ? contactpersonIdInput.value : "";

            var deletedateInput = form.querySelector('input[name="deletedate"]');
            var deleteDate = deletedateInput ? deletedateInput.value : "";

            // Get the URL from the form's action attribute
            var formAction = form.action;
            formAction += "?personid=" + encodeURIComponent(personid) + "&contactpersonid=" + encodeURIComponent(contactpersonid) + "&deletedate=" + encodeURIComponent(deleteDate);

            // Send the form data using JavaScript
            var xhr = new XMLHttpRequest();
            xhr.open("POST", formAction);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

            // Construct the form data
            var formData = new FormData();
            formData.append("personid", personid);
            formData.append("contactpersonid", contactpersonid);
            formData.append("deletedate", deleteDate);

            // Handle the response
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    document.getElementById("confirm-remove").close();
                    document.getElementById("request-sent").showModal();
                }
            };
            // Send the form data
            xhr.send(formData);
        });
    });
})();
